export default "__VITE_ASSET__d2xcT3fz__"